export default __webpack_public_path__ + "static/media/Airbnb1.2c1a68ab.png";